const defaultMainText = `<p>HÄR KAN</p>
                                  <p>DU SKAPA</p>
                                  <p>DIN EGEN</p>
                                  <p>TEXTTAVLA.</p>
                                  <p>FAKTISKT</p>
                                  <p>MED VILKEN</p>
                                  <p>EGEN TEXT</p>
                                  <p>DU VILL!</p>`
export default defaultMainText